(() => {
  if (window.__stitchedSwatchesInitialized) return;
  window.__stitchedSwatchesInitialized = true;

  document.addEventListener('mouseover', (event) => {
    const swatchItem = event.target.closest('.stitched-swatch-item');
    if (!swatchItem) return;

    const wrapper = swatchItem.closest('.stitched-swatches-wrapper');
    if (!wrapper) return;

    const activeLabel = wrapper.querySelector('.stitched-swatches__active-value');
    const swatchName = swatchItem.getAttribute('data-swatch-name');
    if (activeLabel && swatchName) {
      activeLabel.textContent = swatchName;
    }
  });

  document.addEventListener('mouseout', (event) => {
    const swatchItem = event.target.closest('.stitched-swatch-item');
    if (!swatchItem) return;

    const wrapper = swatchItem.closest('.stitched-swatches-wrapper');
    if (!wrapper) return;

    const related = event.relatedTarget;
    if (related && swatchItem.contains(related)) return;

    const nextSwatch = related ? related.closest('.stitched-swatch-item') : null;
    if (nextSwatch && wrapper.contains(nextSwatch)) return;

    const activeLabel = wrapper.querySelector('.stitched-swatches__active-value');
    const defaultLabel = wrapper.getAttribute('data-current-label') || '';
    if (activeLabel) {
      activeLabel.textContent = defaultLabel;
    }
  });

  document.addEventListener('focusin', (event) => {
    const swatchItem = event.target.closest('.stitched-swatch-item');
    if (!swatchItem) return;

    const wrapper = swatchItem.closest('.stitched-swatches-wrapper');
    if (!wrapper) return;

    const activeLabel = wrapper.querySelector('.stitched-swatches__active-value');
    const swatchName = swatchItem.getAttribute('data-swatch-name');
    if (activeLabel && swatchName) {
      activeLabel.textContent = swatchName;
    }
  });

  document.addEventListener('focusout', (event) => {
    const swatchItem = event.target.closest('.stitched-swatch-item');
    if (!swatchItem) return;

    const wrapper = swatchItem.closest('.stitched-swatches-wrapper');
    if (!wrapper) return;

    const related = event.relatedTarget;
    if (related && wrapper.contains(related)) return;

    const activeLabel = wrapper.querySelector('.stitched-swatches__active-value');
    const defaultLabel = wrapper.getAttribute('data-current-label') || '';
    if (activeLabel) {
      activeLabel.textContent = defaultLabel;
    }
  });
})();
